import createFormValueSelector from './createFormValueSelector';
import plain from './structure/plain';
export default createFormValueSelector(plain);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/formValueSelector.js
// module id = 0dLQ
// module chunks = 1